<div class="product-bundle">
  <h2 class="product-bundle__title"><span i18n="@@INCLUDED_ITEMS">Included items</span> ({{ productBundle.length }})</h2>

  @for (product of productBundle; track product) {
    <div class="product-bundle__card">
      <div class="product-bundle__image">
        @if (product.imageUrl) {
          <img
            class="search-results__item-thumb"
            ngSrcset="80w, 160w"
            width="80"
            height="80"
            [ngSrc]="product.imageUrl"
            [alt]="product | translateProductField: 'title'"
            [loaderParams]="{ product: true, fallback: missingProductImageUrl }"
            (error)="product.imageUrl = missingProductImageUrl"
          />
        }
      </div>
      <div class="product-bundle__details">
        <h3 role="heading" class="product-bundle__card-title">{{ product | translateProductField: 'title' }}</h3>
        <p class="product-bundle__qty"><span i18n="@@QUANTITY">Quantity: </span>{{ product.quantity }}</p>
      </div>
    </div>
  }
</div>
